import React, { Component } from "react";
import ReactDOM from "react-dom";
import Icon from "./Icon";
import Menu from "../Menu";

// Hamburger for phone layouts. On phones <Menu> opens its drawer as soon as it
// mounts, so it is only mounted after a tap. The key forces a fresh mount on
// every tap, otherwise a drawer dismissed from inside Menu could not reopen.
class MobileMenuButton extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false, menuKey: 0 };
  }

  render() {
    return (
      <React.Fragment>
        <span
          className="mobile-menu-button"
          role="button"
          aria-label="Open menu"
          onClick={() =>
            this.setState({ open: true, menuKey: this.state.menuKey + 1 })
          }
        >
          <Icon type="menu" />
        </span>
        {/* Portal: keep the drawer out of the header it was opened from, so
            header styles and stacking don't apply to it */}
        {this.state.open &&
          ReactDOM.createPortal(
            <div className="mobile-menu-portal">
              <Menu
                key={this.state.menuKey}
                {...this.props}
                onClose={() => this.setState({ open: false })}
              />
            </div>,
            document.body
          )}
      </React.Fragment>
    );
  }
}

export default MobileMenuButton;
